import { parse } from 'qs';
import { fromUtcToLocalTz } from '@/utils/date';
import dayjs from 'dayjs';
import { toArray } from '@enmon/commons';
import { DataIntegrityIssueType, dataIntegrityIssueDiagnosticCodes } from '@enmon/commons/lib/enmon';
import type { Filter } from '../constants';

export const parseFilter = (search: string) => {
  const parsedSearch = parse(search, {
    ignoreQueryPrefix: true,
    comma: true,
  }) as unknown as {
    filter?: Partial<Filter> & { recordTypes?: string | string[] };
  };

  // Parse strings from URL to proper data types
  if (parsedSearch.filter?.previous) {
    parsedSearch.filter.previous = Number(parsedSearch.filter?.previous);
  }

  if (parsedSearch.filter?.period?.timeWindowShift) {
    parsedSearch.filter.period.timeWindowShift = Number(parsedSearch.filter?.period?.timeWindowShift);
  }

  if (parsedSearch.filter?.period?.year) {
    parsedSearch.filter.period.year = Number(parsedSearch.filter?.period?.year);
  }

  if (parsedSearch.filter?.period?.timeValue) {
    parsedSearch.filter.period.timeValue = Number(parsedSearch.filter?.period?.timeValue);
  }

  const periodFrom = dayjs(fromUtcToLocalTz(parsedSearch.filter?.period?.from ?? 'invalid'));
  if (parsedSearch.filter?.period?.from && periodFrom.isValid()) {
    parsedSearch.filter.period.from = periodFrom;
  }

  const periodTo = dayjs(fromUtcToLocalTz(parsedSearch.filter?.period?.to ?? 'invalid'));
  if (parsedSearch.filter?.period?.to && periodTo.isValid()) {
    parsedSearch.filter.period.to = periodTo;
  }

  if (parsedSearch.filter?.date && dayjs(parsedSearch.filter.date).isValid()) {
    parsedSearch.filter.date = new Date(parsedSearch.filter.date);
  }

  if (parsedSearch.filter?.establishments && !Array.isArray(parsedSearch.filter.establishments)) {
    parsedSearch.filter.establishments = [parsedSearch.filter.establishments];
  }

  if (parsedSearch.filter?.statuses && !Array.isArray(parsedSearch.filter.statuses)) {
    parsedSearch.filter.statuses = [parsedSearch.filter.statuses];
  }

  if (parsedSearch.filter?.thirdParties) {
    parsedSearch.filter.thirdParties = toArray(parsedSearch.filter.thirdParties);
  }

  if (parsedSearch.filter?.integrityIssueTypes) {
    const selected = toArray(parsedSearch.filter.integrityIssueTypes);
    // Older saved URLs selected individual diagnostic outcomes instead of checks.
    parsedSearch.filter.integrityIssueTypes = Object.values(DataIntegrityIssueType).filter(issue =>
      selected.some(value => value === issue || dataIntegrityIssueDiagnosticCodes[issue].some(code => code === value)),
    );
  }

  return parsedSearch;
};
